module.exports = __webpack_public_path__ + "img/birthday.87b3dc35.png";